import script from "./InformationAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./InformationAlert.vue?vue&type=script&setup=true&lang=js"

import "./InformationAlert.vue?vue&type=style&index=0&id=5f5613e2&lang=scss&scoped=true"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f5613e2"]])

export default __exports__